import styled from "styled-components";

export const StyledCanvasStep = styled.div`
  padding: 0 2rem;

  @media (max-width: 900px) {
    padding: 2rem 0.8rem;
  }
`;
